import { EntityType } from '../../definitions/types/Entity';
import { StateType } from '../../definitions/types/StateType';
import { SEARCH_URL } from '../constants/SEARCH_URL';

interface IStateFromEntities {
  url: string;
  entities: EntityType[];
  workspaceClearUrl?: string;
}

export const stateFromEntities = ({
  url,
  entities,
  workspaceClearUrl,
}: IStateFromEntities): StateType => {
  return {
    entities,
    url,
    selected: entities.length ? { number: '1', ...entities[0] } : null,
    workspaceClearUrl: workspaceClearUrl || SEARCH_URL,
  };
};
